import React from 'react';
import PropTypes from 'prop-types';
import { isStreamingLive, isScheduledLive } from '@wix/wix-vod-shared/common';
import { LiveLabel } from '@wix/wix-vod-shared/components';
import getCurrentLocale from '../../utils/current-locale';
import i18n from '../../i18n';
import styles from './live-label.scss';

const shortDateFormat = {
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

const LiveLabelContainer = ({
  videoTitle,
  itemType,
  dateStartLive,
  isMobile,
}) => {
  const isStreaming = isStreamingLive({ itemType });
  const isScheduled = isScheduledLive({ itemType }) && Boolean(dateStartLive);
  const className = `${styles['live-label']} 
    ${isMobile ? styles.mobile : ''} 
    ${isStreaming ? styles.streaming : ''} 
    ${isScheduled ? styles.scheduled : ''}`;
  const mobileProps = {};
  if (isMobile) {
    mobileProps.dateFormat = shortDateFormat;
    mobileProps.noBackground = true;
  }
  const reminderIcon = <div className={styles['reminder-icon']} />;

  return (
    <LiveLabel
      className={className}
      locale={getCurrentLocale()}
      isStreaming={isStreaming}
      isScheduled={isScheduled}
      startTime={dateStartLive}
      liveText={i18n.t('shared.live')}
      scheduledSoonAriaLabel={i18n.t('accessibility.scheduled-soon-label')}
      scheduledAriaLabel={i18n.t('accessibility.scheduled-label')}
      startsInAriaLabel={i18n.t('accessibility.starts-in')}
      reminderAriaLabel={i18n.t('accessibility.reminder')}
      reminderIcon={reminderIcon}
      videoTitle={videoTitle}
      {...mobileProps}
    />
  );
};

LiveLabelContainer.propTypes = {
  itemType: PropTypes.string,
  dateStartLive: PropTypes.number,
  isMobile: PropTypes.bool,
  videoTitle: PropTypes.string,
};

export default LiveLabelContainer;
